export const userManagementBaseUrl = process.env.REACT_APP_USER_MANAGEMENT_BASE_URL
export const projectAuditBaseUrl = process.env.REACT_APP_PROJECTT_AUDIT_BASE_URL

export const userManagement = {
  loginController: {
    login: "/login",
    logout: "/logout",
  },
  enumController: {
    getEntityTypes: "/enums/entity-types",
    getSponsorTypes: "/enums/sponsor-types",
    saveEnumValues: "/enums/add-enum",
  },
  permissionController: {
    getAllPermissions: "/permissions/findAllPermissions",
  },
  roleController: {
    getRoles: "/roles",
    addRole: "/roles",
    findRoleById: "/roles/",
    updateRole: "/roles/",
    deleteRole: "/roles/",
  },
  userController: {
    addUser: "/users",
    findUserById: "/users",
    updateUser: "/users",
    deleteUser: "/users",
    getUsers: "/users",
    forgotPassword: "/users/forgotPassword",
    resetPassword: "/users/resetPassword",
    uploadUsers: "/users/upload",
    findUsername: "/users/username",
    findAllUsers: "/users/findAllUsers"
  },
  userRoleController: {
    getUserRoleById: "/roles",
    updateUserRole: "/roles/updateUserRole",
    deleteUserRoleById: "/roles/deleteUserRole",
    getAllUserRole: "/roles/findAllUserRole",
    saveUserRole: "/roles",
    findAllUserRole: "/roles/findAllUserRole",
  },
  userGroupController: {
    getUserGroupById: "/userGroup/findUserGroup",
    updateUserGroup: "/userGroup/updateUserGroup",
    deleteUserGroupById: "/userGroup/deleteUserGroup",
    getAllUserGroup: "/userGroup/findAllUserGroup",
    saveUserGroup: "/userGroup/saveUserGroup",
  },
  usersController: {
    getUserById: "/users",
    updateUser: "/users",
    deleteUserById: "/users",
    getAllUser: "/users",
    saveUser: "/users",
    resetPassword: "/users/resetPassword",
    getAllUsersWithSearch: "/users/getAllUsersWithSearch",
    getUserByGroupId: "users/group"
  },
  countryController: {
    getAllCountries: "/country/getAllCountries",
    saveCountry: "/country/saveCountry",
    updateCountry: "/country/updateCountry",
    deleteCountry: "/country/deleteCountry",
    getCountryById: "/country/getCountryById",
    getAllCountriesWithSearch: "/country/getAllCountriesWithSearch",
    getAllCountryWithPagination: "/country/getAllCountries",
  },
  cityController: {
    getAllCities: "/city/getAllCities",
  },
  stateController: {
    getState: "/state/getState",
    saveState: "/state/saveState",
    updateState: "/state/updateState",
    deleteState: "/state/deleteState",
    getStateById: "/state/getStateById",
    getAllStates: "/state/getAllStates",
    getAllStatesWithSearch: "/state/getAllStatesWithSearch",
    findAllStates: "/users/findAllStates"
  },
  auditLogController: {
    saveAuditLog: "auditLog/save",
    getAuditLog: "auditLog/find"
  },
  accountCategoryMasterController: {
    getAllAccountCategoryWithPagination: "/accountCategory",
    updateAccountCategory: "/accountCategory/update",
    deleteAccountCategoryById: "accountCategory/delete",
    getAccountCategoryById: "/accountCategory/getById",
    saveAccountCategory: "/accountCategory/save",
    getAllAccountCategoryWithSearch: "/accountCategory/search",
    getAllAccountCategory: '/accountCategory/getAll',
    bulkSaveAccountCategory: "/accountCategory/uploadBulk",
  },
  accountMasterController: {
    getAllAccountWithPagination: "/account",
    updateAccount: "/account/update",
    deleteAccountById: "account/delete",
    getAccountById: "/account/getById",
    saveAccount: "/account/save",
    getAllAccountWithSearch: "/account/search",
    getAllAccount: '/account/getAll',
    bulkSaveAccount: "/account/uploadBulk",
  },
  organizationMasterController: {
    getAllOrganizationMaster: "/organizationMaster",
    saveOrganizationMaster: "/organizationMaster/save",
    updateOrganizationMaster: "/organizationMaster/update",
    deleteOrganizationMaster: "/organizationMaster/delete",
    getOrganizationMasterById: "/organizationMaster/getById",
    getAllOrganizationMasterBySearch: "/organizationMaster/search",
    findAllOrganizationMaster: "/organizationMaster/getAll",
    bulkSaveOrganizationMaster: "/organizationMaster/uploadBulk",
  },
  entityCapController: {
    getAllEntityCap: "/entityCap",
    saveEntityCap: "/entityCap/save",
    updateEntityCap: "/entityCap/update",
    deleteEntityCap: "/entityCap",
    getEntityCapById: "/entityCap", // if needed later
    getAllEntityCapBySearch: "/entityCap/search",
    findAllEntityCap: "/entityCap/getAll",
    getByEntity: "/entityCap/byEntity",
    bulkSaveEntityCap: "/entityCap/uploadBulk",
  },
  entityMasterController: {
    getAllEntityMaster: "/entityMaster",
    saveEntityMaster: "/entityMaster/saveEntityMaster",
    updateEntityMaster: "/entityMaster/updateEntityMaster",
    deleteEntityMaster: "/entityMaster/deleteEntityMaster",
    getEntityMasterById: "/entityMaster",
    getAllEntityMasterBySearch: "/entityMaster/getAllEntityMasterBySearch",
    findAllEntityMaster: "/entityMaster/getAllEntityMaster",
    bulkSaveEntityMaster: "/entityMaster/uploadBulk",
    getDueDiligence: "entityMaster/getDueDiligence",
    downloadReport: "entityMaster/generate",
    getSuccessionDashboard: "/entityMaster/succession-dashboard",
    exportSuccessionDashboard: "/entityMaster/succession-dashboard/export",
  },
  entityTypeMasterController: {
    getAllEntityTypeMaster: "/entityTypeMaster",
    saveEntityTypeMaster: "/entityTypeMaster/saveEntityTypeMaster",
    updateEntityTypeMaster: "/entityTypeMaster/updateEntityTypeMaster",
    deleteEntityTypeMaster: "/entityTypeMaster/deleteEntityTypeMaster",
    getEntityTypeMasterById: "/entityTypeMaster",
    getAllEntityTypeMasterBySearch: "/entityTypeMaster/getAllEntityTypeMasterBySearch",
    findAllEntityTypeMaster: "/entityTypeMaster/getAllEntityTypeMaster",
    bulkSaveEntityTypeMaster: "/entityTypeMaster/uploadBulk",
  },
  investmentMandateTypeController: {
    getAllInvestmentMandateType: "/investmentMandateType",
    saveInvestmentMandateType: "/investmentMandateType/saveInvestmentMandateType",
    updateInvestmentMandateType: "/investmentMandateType/updateInvestmentMandateType",
    deleteInvestmentMandateType: "/investmentMandateType/deleteInvestmentMandateType",
    getInvestmentMandateTypeById: "/investmentMandateType",
    getAllInvestmentMandateTypeBySearch: "/investmentMandateType/getAllInvestmentMandateTypeBySearch",
    findAllInvestmentMandateType: "/investmentMandateType/getAllInvestmentMandateType",
    bulkSaveInvestmentMandateTypeMaster: "/investmentMandateType/uploadBulk",

  },
  assetTypeController: {
    getAllAssetType: "/assetType",
    saveAssetType: "/assetType/saveAssetType",
    updateAssetType: "/assetType/updateAssetType",
    deleteAssetType: "/assetType/deleteAssetType",
    getAssetTypeById: "/assetType",
    getAllAssetTypeBySearch: "/assetType/getAllAssetTypeBySearch",
    findAllAssetType: "/assetType/getAllAssetType",
    bulkSaveAssetType: "/assetType/uploadBulk",
  },
  assetsController: {
    getAllAssets: "/assets",
    saveAssets: "/assets/saveAssets",
    updateAssets: "/assets/updateAssets",
    deleteAssets: "/assets/deleteAssets",
    getAssetsById: "/assets",
    getAllAssetsBySearch: "/assets/getAllAssetsBySearch",
    findAllAssets: "/assets/getAllAssets",
    bulkSaveAssets: "/assets/uploadBulk",
    getAssetRiskAssessment: "assets/getAssetRiskAssessment",
    downloadReport: "assets/generate",
    exportAssetsCsv: "/assets/exportAssetsCsv",
  },
  investmentMasterController: {
    getAllInvestmentMaster: "/investmentMaster",
    saveInvestmentMaster: "/investmentMaster/saveInvestmentMaster",
    updateInvestmentMaster: "/investmentMaster/updateInvestmentMaster",
    deleteInvestmentMaster: "/investmentMaster/deleteInvestmentMaster",
    getInvestmentMasterById: "/investmentMaster",
    getAllInvestmentMasterBySearch: "/investmentMaster/getAllInvestmentMasterBySearch",
    findAllInvestmentMaster: "/investmentMaster/getAllInvestmentMaster",
    bulkSaveInvestmentMaster: "/investmentMaster/uploadBulk",
  },
  sponsorMasterController: {
    getAllSponsorMaster: "/sponserMaster",
    saveSponsorMaster: "/sponserMaster/save",
    updateSponsorMaster: "/sponserMaster/update",
    deleteSponsorMaster: "/sponserMaster/delete",
    getSponsorMasterById: "/sponserMaster/getById",
    getAllSponsorMasterBySearch: "/sponserMaster/search",
    findAllSponsorMaster: "/sponserMaster/getAll",
    bulkSaveSponsorMaster: "/sponserMaster/uploadBulk",
  },
  familyOfficeMasterController: {
    getAllFamilyOfficeMaster: "/familyOfficeMaster",
    saveFamilyOfficeMaster: "/familyOfficeMaster/saveFamilyOfficeMaster",
    updateFamilyOfficeMaster: "/familyOfficeMaster/updateFamilyOfficeMaster",
    deleteFamilyOfficeMaster: "/familyOfficeMaster/deleteFamilyOfficeMaster",
    getFamilyOfficeMasterById: "/familyOfficeMaster",
    getAllFamilyOfficeMasterBySearch: "/familyOfficeMaster/getAllFamilyOfficeMasterBySearch",
    findAllFamilyOfficeMaster: "/familyOfficeMaster/getAllFamilyOfficeMaster",
    bulkSaveFamilyOfficeMaster: "/familyOfficeMaster/uploadBulk",
  },
  documentTypeController: {
    getAllDocumentType: "/documentType",
    saveDocumentType: "/documentType/saveDocumentType",
    updateDocumentType: "/documentType/updateDocumentType",
    deleteDocumentType: "/documentType/deleteDocumentType",
    getDocumentTypeById: "/documentType",
    getAllDocumentTypeWithSearch: "/documentType/getAllDocumentTypeWithSearch",
    findAllDocumentType: "/documentType/getAllDocumentType",
    bulkSaveDocumentType: "/documentType/uploadBulk",
  },
  documentMasterController: {
    getAllDocumentMaster: "/documentMaster",
    saveDocumentMaster: "/documentMaster/saveDocumentMaster",
    updateDocumentMaster: "/documentMaster/updateDocumentMaster",
    deleteDocumentMaster: "/documentMaster/deleteDocumentMaster",
    getDocumentMasterById: "/documentMaster",
    getAllDocumentMasterWithSearch: "/documentMaster/getAllDocumentMasterWithSearch",
    findAllDocumentMaster: "/documentMaster/findAllDocumentMaster",
    bulkSaveDocumentMaster: "/documentMaster/uploadBulk",
  },
  dashboardController: {
    getDashboardData: "/dashboard",
    getQuickStats: "/dashboard/quick-stats",
    getUniversalScore: "/dashboard/universal-score",
    exportTables: "/dashboard/tables",
    exportScriptureReferences: "/dashboard/scripture-references",
    exportFinancialStatements: "/dashboard/financial-statements",
  },
  riskAssessmentLogsController: {
    getAll: "/riskAssessmentLog/getAll",
    getById: "/riskAssessmentLog/find",
    save: "/riskAssessmentLog/save",
    update: "/riskAssessmentLog/update",
    delete: "/riskAssessmentLog/delete",
    search: "/riskAssessmentLog/search",
    getAllWithPagination: "/riskAssessmentLog",
    downloadReport: "/riskAssessmentLog/generate",
  },
  opportunityTypeController: {
    getAllOpportunityType: "/opportunityType",
    saveOpportunityType: "/opportunityType/saveOpportunityType",
    updateOpportunityType: "/opportunityType/updateOpportunityType",
    deleteOpportunityType: "/opportunityType/deleteOpportunityType",
    getOpportunityTypeById: "/opportunityType",
    getAllOpportunityTypeBySearch: "/opportunityType/getAllOpportunityTypeBySearch",
    findAllOpportunityType: "/opportunityType/getAllOpportunityType",
    bulkSaveOpportunityType: "/opportunityType/uploadBulk",
  },
  opportunityMasterController: {
    getAllOpportunityMaster: "/opportunity",
    saveOpportunityMaster: "/opportunity/saveOpportunity",
    updateOpportunityMaster: "/opportunity/updateOpportunity",
    deleteOpportunityMaster: "/opportunity/deleteOpportunity",
    getOpportunityMasterById: "/opportunity",
    getAllOpportunityMasterBySearch: "/opportunity/searchOpportunity",
    findAllOpportunityMaster: "/opportunity/getAll",
    bulkSaveOpportunityMaster: "/opportunity/uploadBulk",
  },
  opportunityApplicationController: {
    getAllOpportunityApplication: "/opportunityApplication",
    saveOpportunityApplication: "/opportunityApplication/saveOpportunityApplication",
    updateOpportunityApplication: "/opportunityApplication/updateOpportunityApplication",
    deleteOpportunityApplication: "/opportunityApplication/deleteOpportunityApplication",
    getOpportunityApplicationById: "/opportunityApplication",
    getAllOpportunityApplicationBySearch: "/opportunityApplication/getAllOpportunityApplicationBySearch",
    findAllOpportunityApplication: "/opportunityApplication/getAllOpportunityApplication",
    bulkSaveOpportunityApplication: "/opportunityApplication/uploadBulk",
    getOpportunityDueDiligence: "/opportunityApplication/getOpportunityDueDiligence",
    downloadReport: "/opportunityApplication/generate",
    addToProject: "/opportunityApplication/addToProject",
    addToAudit: "/opportunityApplication/addToAudit",
    addToFinance: "/opportunityApplication/addToFinance",
    getProjectPhaseActivities: "/opportunityApplication/project-phase-activities/by-ids",
    getAudits: "/opportunityApplication/audits/by-ids",
    getProjectsByIds: "/opportunityApplication/projects/by-ids",
    searchProjectPhaseActivities: "/opportunityApplication/project-phase-activities/search",
    searchAudits: "/opportunityApplication/audits/search"
  },
  opportunityApplicationInterviewController: {
    getAllOpportunityApplicationInterview: "/opportunityApplicationInterview",
    saveOpportunityApplicationInterview: "/opportunityApplicationInterview/saveOpportunityApplicationInterview",
    updateOpportunityApplicationInterview: "/opportunityApplicationInterview/updateOpportunityApplicationInterview",
    deleteOpportunityApplicationInterview: "/opportunityApplicationInterview/deleteOpportunityApplicationInterview",
    getOpportunityApplicationInterviewById: "/opportunityApplicationInterview",
    getAllOpportunityApplicationInterviewBySearch: "/opportunityApplicationInterview/getAllOpportunityApplicationInterviewBySearch",
    findAllOpportunityApplicationInterview: "/opportunityApplicationInterview/getAllOpportunityApplicationInterview",
    bulkSaveOpportunityApplicationInterview: "/opportunityApplicationInterview/uploadBulk",
  },
  opportunityAllocationController: {
    getAllOpportunityAllocation: "/opportunityAllocation",
    saveOpportunityAllocation: "/opportunityAllocation/saveOpportunityAllocation",
    updateOpportunityAllocation: "/opportunityAllocation/updateOpportunityAllocation",
    deleteOpportunityAllocation: "/opportunityAllocation/deleteOpportunityAllocation",
    getOpportunityAllocationById: "/opportunityAllocation",
    getAllOpportunityAllocationBySearch: "/opportunityAllocation/getAllOpportunityAllocationBySearch",
    findAllOpportunityAllocation: "/opportunityAllocation/getAllOpportunityAllocation",
    bulkSaveOpportunityAllocation: "/opportunityAllocation/uploadBulk",
  },
  memberInterviewRecordController: {
    getAllMemberInterviewRecord: "/memberInterviewRecord",
    saveMemberInterviewRecord: "/memberInterviewRecord/save",
    updateMemberInterviewRecord: "/memberInterviewRecord/update",
    deleteMemberInterviewRecord: "/memberInterviewRecord/delete",
    getMemberInterviewRecordById: "/memberInterviewRecord",
    getAllMemberInterviewRecordBySearch: "/memberInterviewRecord/search",
    findAllMemberInterviewRecord: "/memberInterviewRecord/findAll",
    bulkSaveMemberInterviewRecord: "/memberInterviewRecord/uploadBulk",
  },
  mentorshipMasterController: {
    getAllMentorshipMasterWithPagination: "/mentorshipMaster",
    saveMentorshipMaster: "/mentorshipMaster/saveMentorshipMaster",
    updateMentorshipMaster: "/mentorshipMaster/updateMentorshipMaster",
    deleteMentorshipMaster: "/mentorshipMaster/deleteMentorshipMaster",
    getMentorshipMasterById: "/mentorshipMaster",
    getAllMentorshipMasterBySearch: "/mentorshipMaster/getAllMentorshipMasterBySearch",
    findAllMentorshipMaster: "/mentorshipMaster/getAllMentorshipMaster",
    downloadMentorship: "/mentorshipMaster/downloadMentorship",
    bulkSaveMentorshipMaster: "/mentorshipMaster/uploadBulk",
    searchByDateRange: "/mentorshipMaster/searchByDateRange",
    exportMentorship: "/mentorshipMaster/export",
  },
  eventMasterController: {
    getAllEventMasterWithPagination: "/eventMaster",
    saveEventMaster: "/eventMaster/saveEventMaster",
    updateEventMaster: "/eventMaster/updateEventMaster",
    deleteEventMaster: "/eventMaster/deleteEventMaster",
    getEventMasterById: "/eventMaster",
    findAllEventMaster: "/eventMaster/getAllEventMaster",
    bulkSaveEventMaster: "/eventMaster/uploadBulk",
  },
  eventTypeController: {
    getAllEventTypeWithPagination: "/eventType",
    saveEventType: "/eventType/saveEventType",
    updateEventType: "/eventType/updateEventType",
    deleteEventType: "/eventType/deleteEventType",
    getEventTypeById: "/eventType",
    findAllEventType: "/eventType/getAllEventType",
    bulkSaveEventType: "/eventType/uploadBulk",
  },
  sovereignEventLedgerController: {
    getAllLedgerWithPagination: "/sovereignEventLedger",
    saveLedger: "/sovereignEventLedger/saveLedger",
    updateLedger: "/sovereignEventLedger/updateLedger",
    deleteLedger: "/sovereignEventLedger/deleteLedger",
    getLedgerById: "/sovereignEventLedger",
    findAllLedger: "/sovereignEventLedger/getAllLedger",
    generateDRPlan: "/sovereignEventLedger/generateDRPlan",
  },
};